module.exports = __webpack_public_path__ + "img/img-top.e22f7262.png";